import AriaLink from '../aria-link/aria-link.js';

class PartnerLink extends AriaLink {
    constructor() {
        super();
        this._counterId = 77836015;
    }

    /**
     * @type {Promise<string>}
     */
    get _clientId() {
        return new Promise((resolve) => {
            ym(this._counterId, 'getClientID', resolve);
        });
    }

    /**
     * @override
     */
    async open() {
        const url = this.getAttribute('href');

        if (url.endsWith('&id=')) {
            this.setAttribute('href', url + (await this._clientId));
        }

        super.open();
        ym(this._counterId, 'reachGoal', 'school');
    }
}

customElements.define('partner-link', PartnerLink);
export default PartnerLink;
